import { render } from "./SectionPopup.vue?vue&type=template&id=02324661"
import script from "./SectionPopup.vue?vue&type=script&lang=js"
export * from "./SectionPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__